import {
    Badge,
    IconButton,
    Menu,
    MenuItem,
    Typography
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { Scrollbars } from 'react-custom-scrollbars-2';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import _ from 'lodash';
import { formatLocalDateForDispaly } from '../../../../core/DateTimeHelper';
import { pageNotiState } from 'src/slices/pageNotificationSlice';
import { useSelector } from "react-redux";

function Notification() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [invisible, setInvisible] = useState(true);
    const { recordingAndArchivedNotifications } = useSelector(pageNotiState);

    useEffect(() => {
        if (recordingAndArchivedNotifications.length != 0) {
            setInvisible(false);
        }

    }, [recordingAndArchivedNotifications])

    const handleClose = () => {
        setAnchorEl(null);
        setInvisible(true);
    };
    const handleOpenNotification = (event) => {
        setAnchorEl(event.currentTarget);
        setInvisible(true);
    }

    return (
        <div>
            <IconButton sx={{ marginRight: '-20px' }} onClick={handleOpenNotification} >
                <Badge color="secondary" variant="dot" invisible={invisible}>
                    <NotificationsNoneOutlinedIcon />
                </Badge>
            </IconButton>
            <Menu
                id="basic-menu"
                keepMounted
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    sx: {
                        width: '454px',
                        '& .MuiMenu-list': {
                            padding: 0,
                            color: 'white',
                            backgroundColor: '#000000',
                        },
                        '& .MuiMenuItem-root.MuiButtonBase-root': {
                            height: '50px',
                            padding: '16px',
                            borderRadius: '0px',
                            borderBottom: '1px solid #303030',
                            color: 'white',
                            ':hover': {
                                background: '#303030'
                            }
                        },
                        '& .MuiTypography-root': {
                            color: 'white',
                        }
                    }
                }}
            >
                <MenuItem >
                    <Typography sx={{ fontFamily: 'lato', fontStyle: 'normal', fontWeight: 700, fontSize: '14px', lineHeight: '18px', display: 'flex', alignItems: 'center', letterSpacing: '0.16px', color: '#FFFFFFF' }}> Notifications</Typography>
                </MenuItem>

                <Scrollbars
                    autoHeight
                    autoHide
                    autoHeightMin={200}
                    autoHideTimeout={500}
                    renderView={(pros) => <div {...pros} />}
                    renderTrackVertical={(pros) => <div {...pros} className="vtrack" />}
                    renderThumbVertical={(pros) => <div {...pros} className="vthumb" />}

                >
                    {
                        _.map(recordingAndArchivedNotifications, x => {
                            let icon = x.status == 'Completed' ? <TaskAltIcon color='success' style={{ margin: '10px' }} /> :
                                <ErrorOutlineIcon color='error' style={{ margin: '10px' }} />
                            let message = '';
                            switch (x.videoType) {
                                case 0:
                                    if (x.status == 'Completed') {
                                        message = <span>Recording #{x.videoTaskId}  has been saved in Recorded video.<br />
                                            Completed on {formatLocalDateForDispaly(x.date)}</span>;
                                    } else {
                                        message = <span>Recording #{x.videoTaskId} failed to save. <br />
                                            Attempted on {formatLocalDateForDispaly(x.date)}</span>;
                                    }
                                    break;
                                case 1:
                                    if (x.status == 'Completed') {
                                        message = <span>Archive #{x.videoTaskId} successfully exported to Recorded Videos.<br />
                                            Completed on {formatLocalDateForDispaly(x.date)}</span>
                                    } else {
                                        message = <span>Archive #{x.videoTaskId}  export failed. <br />
                                            Attempted on {formatLocalDateForDispaly(x.date)}</span>
                                    }
                                    break;
                            }

                            let notification = <Typography sx={{ fontFamily: 'lato', fontStyle: 'normal', fontWeight: 400, fontSize: '12px', lineHeight: '16px', display: 'flex', alignItems: 'center', letterSpacing: '0.16px', color: '#FFFFFFF' }}>
                                {icon}  {message}
                            </Typography>

                            return <MenuItem key={x.videoTaskId}> <div style={{ display: 'flex' }}>
                                {notification}
                            </div>
                            </MenuItem>
                        })
                    }
                </Scrollbars>
            </Menu>
        </div>
    );
}

export default Notification;
